import { Grid } from '@material-ui/core';
import { Add, RoomSharp } from '@material-ui/icons';
import Button from 'components/button';
import Text from 'components/text';
import { autobind } from 'core-decorators';
import { reverse } from 'core/urls';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import AddressCard from './address-card';
import styles from './styles.css';

@autobind
export default class AddressGrid extends Component {
    static propTypes = {
        addresses: PropTypes.array.isRequired,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        onChange: PropTypes.func,
        onDelete: PropTypes.func,
        onBlur: PropTypes.func,
        returnUrl: PropTypes.string,
        returnData: PropTypes.object,
        disableCreation: PropTypes.bool,
    };

    static contextTypes = {
        router: PropTypes.object,
    };

    render() {
        const defaultAddress = this.props.addresses.find(address => address.isDefault === true);
        return (
            <Grid container spacing={4} className={styles.root}>
                {this.context.router.route.location.pathname === reverse('addressBook') ? (
                    this.props.addresses.map(address => ((
                        <Grid item xs={12}>
                            <AddressCard
                                key={address.id}
                                address={address}
                                selected={this.props.value === address.id}
                                onChange={this.props.onChange}
                                onDelete={this.props.onDelete}
                                onBlur={this.props.onBlur}
                            />
                        </Grid>
                    )))
                ) : (
                    defaultAddress && (
                        <Grid item xs={12}>
                            <AddressCard
                                key={defaultAddress.id}
                                address={defaultAddress}
                                selected={this.props.value === defaultAddress.id}
                                onChange={this.props.onChange}
                                onDelete={this.props.onDelete}
                                onBlur={this.props.onBlur}
                            />
                        </Grid>
                    ) || (
                        this.props.addresses.map(address => ((
                            <Grid item xs={12}>
                                <AddressCard
                                    key={address.id}
                                    address={address}
                                    selected={this.props.value === address.id}
                                    onChange={this.props.onChange}
                                    onDelete={this.props.onDelete}
                                    onBlur={this.props.onBlur}
                                />
                            </Grid>
                        )))
                    )
                )}
                {!this.props.disableCreation &&
                    this.context.router.route.location.pathname === reverse('addressBook') && (
                        <Grid
                            item
                            xs={12}
                            className={styles.buttonContainer}>
                            <Link to={{
                                pathname: reverse('createAddress'),
                                state: {returnUrl: this.props.returnUrl, returnData: this.props.returnData},
                            }}>
                                <Button
                                    className={styles.addAddress}
                                    theme='yellow'
                                    onClick={this.handleAddress}>
                                    <Text
                                        variant='h2'
                                        className={styles.buttonText}
                                        bold='bold'>
                                        <Add fontSize='large' />
                                            Agregar dirección
                                    </Text>
                                </Button>
                            </Link>
                        </Grid>
                    )
                }
                {this.context.router.route.location.pathname !== reverse('addressBook') && (
                    <Grid item xs={12} className={styles.buttonContainer}>
                        <Link to={{
                            pathname: reverse('addressBook'),
                            state: {returnUrl: this.props.returnUrl, returnData: this.props.returnData},
                        }}>
                                <Text
                                    variant='h4'
                                    className={styles.buttonText}
                                    onClick={this.handleAddress}
                                    bold='bold'>
                                        <RoomSharp/>
                                        Agregar o cambiar dirección
                                </Text>
                        </Link>
                    </Grid>
                )}
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./components/address-grid/index.js